import { Page } from 'layouts/Page';
import { ChangeHistory } from 'components/EMManagement/EMManagementId/СhangeHistory';

export const ChangeHistoryPage = () => {
	return (
		<Page title="Change History – EAS Control Center">
			<ChangeHistory />
		</Page>
	);
};
